/**
 * Created by claude on 22.07.26.
 * Scene component extracted from ComicsScene
 */

const ComicsPlayer = function (stages, animation) {
    this.stages = stages;
    this.animation = animation;

    this.stage = -1;
};

ComicsPlayer.prototype.onChangeStage = function () {
    if (this.dialogueStages === undefined || this.dialogueStages < 1) {
        this.next();
        this.dialogueStages = this.comics.dialogueStages || 1;
    }
    this.dialogueStages--;
};

ComicsPlayer.prototype.next = function () {
    this.stage++;
    if (this.stage >= this.stages.length) {
        return;
    }
    this.comics = this.stages[this.stage];
    this.runAnimation();
};

ComicsPlayer.prototype.completeShowAnimation = function () {
    if (this.inAnimation) {
        if (this.comics.idleAnimation) {
            this.animation.setCompleteListener();
            this.inAnimation = false;
            this.animation.setAnimation(0, this.comics.idleAnimation, true);
        }
    }
};

ComicsPlayer.prototype.runAnimation = function () {
    this.animation.setTimeScale(1);
    if (this.comics.showAnimation) {
        this.inAnimation = true;
        this.animation.setAnimation(0, this.comics.showAnimation, false);
        this.animation.setCompleteListener(this.animation.createListener(this.completeShowAnimation.bind(this)));
    } else {
        this.inAnimation = false;
        this.animation.setAnimation(0, this.comics.idleAnimation, true);
    }
};

class ComicsSceneComponent extends ScriptComponent {
    onCreate() {
        this.data = (PrefabBuilder.resolveProperty(this.options.args, this.context) || [])[0];
    }

    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setBundles(this.listBundles());
    }

    hasBg() {
        return !!bundles.comicses.urls.bg;
    }

    buildBg() {
        const bgSize = cleverapps.resolution.getBgSize();

        const bg = this.bg = new cc.Sprite(bundles.comicses.urls.bg);
        bg.setAlignment(this.node.width / 2, this.node.height / 2);
        this.bg.baseScale = Math.max(bgSize.width / bg.width, bgSize.height / bg.height);
        bg.setScale(this.bg.baseScale);

        return bg;
    }

    buildAnimationNode() {
        const data = this.data;

        const animationNode = this.animationNode = new cc.Node();
        animationNode.setAnchorPoint(0.5, 0.5);
        animationNode.setContentSize(this.node.getContentSize());
        animationNode.setAlignment(this.node.width / 2, this.node.height / 2);
        const bgSize = cleverapps.resolution.getBgSize();
        animationNode.setScale(Math.max(bgSize.width / this.node.width, bgSize.height / this.node.height));

        const animation = this.animation = new cleverapps.Spine(data.json);
        animationNode.addChild(animation);
        animation.setAlignment(animationNode.width / 2, animationNode.height / 2);
        animation.setAnimation(0, data.stages[0].showAnimation || data.stages[0].idleAnimation, false);
        animation.setScale(Math.max(this.node.width / animation.width, this.node.height / animation.height));
        animation.setTimeScale(0);

        return animationNode;
    }

    onReady() {
        this.player = new ComicsPlayer(this.data.stages, this.animation);

        this.onResize();
    }

    onPlayIntro(f) {
        const dialogue = this.dialogue = new Dialogue(this.data.dialogue, {
            autoClose: true,
            autoScroll: 3
        });

        dialogue.on("afterClose", f);
        dialogue.on("changedStage", this.player.onChangeStage.bind(this.player));

        new DialogueView(dialogue, {
            withShadow: false
        });

        return true;
    }

    onResize() {
        const bgSize = cleverapps.resolution.getBgSize();

        if (this.bg) {
            this.bg.baseScale = Math.max(bgSize.width / this.bg.width, bgSize.height / this.bg.height);
            this.bg.setScale(this.bg.baseScale);
        }
        if (this.animationNode) {
            this.animationNode.setScale(Math.max(bgSize.width / this.node.width, bgSize.height / this.node.height));

            this.animation.setScale(Math.max(this.node.width / this.animation.width, this.node.height / this.animation.height));
        }

        this.bg && this.bg.setAlignment(this.node.width / 2, this.node.height / 2);
        this.animationNode && this.animationNode.setAlignment(this.node.width / 2, this.node.height / 2);
    }

    listBundles() {
        let result = ["dialogues"];
        if (this.data.bundles) {
            result = result.concat(this.data.bundles);
        }
        return result;
    }
}

Prefab.registerComponent("ComicsSceneComponent", ComicsSceneComponent);

const ComicsScene = {
    showComics: function (f, comics) {
        const comicsScene = Prefab.instantiate(bundles.main.jsons.comicsscene_prefab_json, { args: [comics] });

        cleverapps.scenes.replaceScene(comicsScene, () => {
            comicsScene.sceneComponent.playIntro(f);
        });
    }
};
